// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * References another ContentFilter element by index (for compound filters).
 */
export class ElementOperand implements flatbuffers.IUnpackableObject<ElementOperandT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ElementOperand {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsElementOperand(bb: flatbuffers.ByteBuffer, obj?: ElementOperand): ElementOperand {
    return (obj || new ElementOperand()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsElementOperand(
    bb: flatbuffers.ByteBuffer,
    obj?: ElementOperand,
  ): ElementOperand {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ElementOperand()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  index(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startElementOperand(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addIndex(builder: flatbuffers.Builder, index: number) {
    builder.addFieldInt32(0, index, 0);
  }

  static endElementOperand(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createElementOperand(builder: flatbuffers.Builder, index: number): flatbuffers.Offset {
    ElementOperand.startElementOperand(builder);
    ElementOperand.addIndex(builder, index);
    return ElementOperand.endElementOperand(builder);
  }

  unpack(): ElementOperandT {
    return new ElementOperandT(this.index());
  }

  unpackTo(_o: ElementOperandT): void {
    _o.index = this.index();
  }

  unpackFields(...fields: string[]): ElementOperandT {
    const t = new ElementOperandT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("index")) {
      t.index = this.index();
    }
    return t;
  }
}

export class ElementOperandT implements flatbuffers.IGeneratedObject {
  constructor(public index: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return ElementOperand.createElementOperand(builder, this.index);
  }

  clone(): ElementOperandT {
    const obj = new ElementOperandT();
    obj.index = this.index;
    return obj;
  }

  equals(other: ElementOperandT): boolean {
    if (this.index !== other.index) return false;
    return true;
  }
}

export function verifyElementOperand(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
  } finally {
    verifier.popDepth();
  }
}
